import { SubscriptionType } from '@app/enums/subscription-type.enum';

/**
 * Subscription UI Configuration Item to determine what parts of the Subscription detail used to configure, enable or disable
 * common subscription components
 */
export class SubscriptionUIConfigurationItem {
  constructor(
    public subscriptionType: SubscriptionType,
    public showRecommendedFoundationalCourses: boolean,
    public showRecommendedFoundationalHeading: boolean,
    public showTrainingForAllCXRoles: boolean,
    public showCertifications: boolean,
    public showFlexibleMethodsOfLearning: boolean,
    public showHeroBannerButton: boolean,
    public showTestimonials: boolean,
    public showContactUs: boolean,
    public showCMSContent: boolean,
    public showAnnouncements: boolean,
    public showAnnouncementsButton: boolean,
    public showLearningPaths: boolean,
    public showModal: boolean,
    public actionLabel: string,
    public certificationRoute: string,
    public certificationDescription: string,
    public trainingForAllCXRoles?: string[],
    public description?: string,
    public subscriptionAnnouncementSlug?: string,
    public courseIds?: number[],
    public customClass?: string,
    public showViewAllButton?: boolean
  ) {}
}
